import React, { Component } from 'react';
import { Toast, ToastHeader, Fade } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class ToastItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
        }
        this.timeout = null;
    }

    componentDidMount = () => {
        this.props.log('ToastItem.js/componentDidMount');
        if (parseInt(this.props.toast.delay) > 0) {
            this.timeout = setTimeout(() => {
                this.setState({ show: false })
            }, parseInt(this.props.toast.delay * 1000));
        }
    }

    componentWillUnmount = () => {
        this.props.log('ToastItem.js/componentWillUnmount');
        clearTimeout(this.timeout);
    }

    onDismiss = () => {
        this.props.log('ToastItem.js/onDismiss');
        this.setState({ show: false })
    }

    onClose = () => {
        this.props.log('ToastItem.js/onClose');
        clearTimeout(this.timeout);
        this.props.onDelete(this.props.toast.id);
    }

    render() {
        this.props.info('ToastItem.js/render');
        return (
            <Fade in={this.state.show} onExited={this.onClose}>
                <Toast className={"m-1 text-left bg-"+this.props.toast.color} animation={"false"}>
                    <ToastHeader toggle={this.onDismiss}>
                        {this.props.toast.str}
                    </ToastHeader>
                </Toast>
            </Fade>
        )
    }
};

export default ToastItem;